<template>
  <!-- Sidebar -->

  <v-card class="sidebar-menu">
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      permanent
      disable-resize-watcher
    >
      <v-list-item>
        <router-link to="/main/home" style="text-align:center">
          <img class="sidebar-logo mt-5" src="../images/nova_avia_logo.png" />
        </router-link>
        <v-btn
          color="white"
          icon
          @click.stop="mini = !mini"
          style="margin-right:-20px"
        >
          <img style="width:20px" src="../images/curved-arrow.png" />
        </v-btn>
      </v-list-item>

      <v-list>
        <router-link to="/main/home">
          <v-list-item>
            <v-list-item-icon>
              <i class="fas fa-fw fa-home"></i>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>ANA SAYFA</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>

        <v-list-group>
          <template v-slot:activator>
            <v-list-item-icon>
              <i class="fas fa-fw fa-plane-departure"></i>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>UÇUŞ</v-list-item-title>
            </v-list-item-content>
          </template>

          <router-link to="/pages/flight/flightReservationMonitor">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-list-alt "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Rezervasyon</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/flight/flightWizard">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-paper-plane"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Uçuş Ekleme Sihirbazı</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/pages/flight/flightChange">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-sync"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Uçuş Değişimi</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/flight/flightOrderChange">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-retweet"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Uçuş Sipariş Değişikliği</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/flight/flightPassengerList">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-users "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Uçuş Yolcu Listesi</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/pages/flight/servisMarkup">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-plus-square "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>WEB Servis Markup</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/flight/providerMarkup">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-plus-circle "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Provider Markup</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>


          <router-link to="/pages/flight/xml">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-braille "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>XML</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/flight/paxReport">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-file-alt"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Pax Raporu</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <!-- <router-link to="/pages/flight/flightSearch">
            <v-list-item>
              <v-list-item-icon>
              <i class="fas fa-fw fa-search"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Uçuş Arama</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link> -->
        </v-list-group>

        <v-list-group>
          <template v-slot:activator>
            <v-list-item-icon>
              <i class="fas fa-fw fa-car"  style="color:springgreen"></i>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title style="color:springgreen">TRANSFER</v-list-item-title>
            </v-list-item-content>
          </template>

          <router-link to="/pages/transfer/transferReservationMonitor">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-list"  style="color:springgreen"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title  style="color:springgreen">Transfer Rezervasyon</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/pages/transfer/transferPassengerList">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-users "  style="color:springgreen"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title  style="color:springgreen">Transfer Yolcu Listesi</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/pages/transfer/transferRegions">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-map-marker-alt"  style="color:springgreen"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title  style="color:springgreen">Transfer Bölgeleri</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/pages/transfer/transfers">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-car-side"  style="color:springgreen"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title  style="color:springgreen">Transferler</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          
        </v-list-group>


        <v-list-group>
          <template v-slot:activator>
            <v-list-item-icon>
              <i class="fas fa-fw fa-edit "></i>
            </v-list-item-icon>

            <v-list-item-title>TANIMLAMALAR</v-list-item-title>
          </template>

          <router-link to="/pages/definitions/airports">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-list-alt"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Havaalanları</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/definitions/companies">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-building "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Havayolu Şirketleri</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/pages/definitions/countries">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-globe fa-building "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Ülkeler</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/definitions/cities">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-city fa-building "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Şehirler</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          
          <router-link to="/pages/definitions/providers">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-hands-helping "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Tedarikçiler</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <!-- <router-link to="/pages/definitions/flightClasses">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-plus-square "></i>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Uçuş Sınıfları</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/pages/definitions/flightSegments">
            <v-list-item>
              <v-list-item-icon>
                <i class="far fa-fw fa-plus-square "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  Uçak Bölümleri
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/pages/definitions/salesChannels">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-comments "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  Satış Kanalları
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link> -->
          <router-link to="/pages/definitions/exchangeRates">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-recycle"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  Kur Oranları
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/pages/definitions/flightRoutes">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-route "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  Uçuş Rotaları
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/pages/definitions/flightRoutesXML">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-code "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  Uçuş Rotaları-XML
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/pages/definitions/agencies">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-shapes"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  Acenteler
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/pages/definitions/currencies">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-money-bill-wave "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  Para Birimleri
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list-group>

        <v-list-group>
          <template v-slot:activator>
            <v-list-item-icon>
              <i class="fas fa-fw fa-balance-scale "></i>
            </v-list-item-icon>

            <v-list-item-title>FİNANS</v-list-item-title>
          </template>

          <router-link to="/pages/finance/accountBalanceManagements">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-cash-register"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Hesap Bakiye Yönetimi</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

         <router-link to="/pages/finance/accountActivities">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-exchange-alt "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Hesap Hareketleri</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/finance/bankPos">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-credit-card"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Banka Pos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <!--  <router-link to="/pages/finance/exchangeRateUpdate">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-percentage "></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Kur Oranı Güncelleme</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link> -->
        </v-list-group>


        <v-list-group>
          <template v-slot:activator>
            <v-list-item-icon>
              <i class="fas fa-fw fa-users"></i>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>KULLANICILAR</v-list-item-title>
            </v-list-item-content>
          </template>

          <router-link to="/pages/users/userManagement">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-user-cog"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Kullanıcı Yönetimi</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/users/apiUserCreate">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-key"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>API Kullanıcısı Oluştur</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list-group>

           <a target="_blank" href="http://uptime.charterscanners.com/dashboard">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-check"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>SİSTEM KONTROL</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </a>
          <a target="_blank" href="https://stats.charterscanners.com">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-chart-line"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>SİTE ZİYARETÇİLERİ</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </a>
         

          <router-link to="/pages/flight/queryTool">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-code"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>UÇUŞ SORGU ARACI</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </router-link>

          <router-link to="/pages/logs/serviceLogs">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-clipboard-list"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>SERVİS LOGLARI</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/bot/botManagement">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-robot"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>BOT YÖNETİMİ</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/statistics/queryStatistics">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-chart-bar"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>SORGU SAYILARI</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/statistics/providerUpstreamStatistics">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-cloud-upload-alt"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>SAĞLAYICI SORGULARI</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/statistics/apiMonitoring">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-fw fa-heartbeat"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>API İZLEME</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>


<script>
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class SideBarMenu extends Vue {
  data() {
    return {
      drawer: false,
      mini: false,
    };
  }
}
</script>

<style scoped>
.sidebar-logo {
  width: 80%;
}

::v-deep .theme--light.v-navigation-drawer {
  background-image: linear-gradient(180deg, #23376d 10%, #5bbde6 100%);
}

.v-sheet.v-card {
  border-radius: 0px;
}

.v-list-item .v-list-item__title {
  line-height: 1.2;
  color: white;
  font-size: 14px;
}

.v-list-item__icon:first-child {
  margin-right: 20px !important;
  font-size: 18px;
  color: white;
}

::v-deep
  .v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon
  i {
  color: white;
}

a:hover {
  text-decoration: none !important;
}

@media only screen and (max-width: 992px) {
  .sidebar-menu {
    display: none;
  }
}
</style>
